import { type WavWriterFailurePayload } from '@heidi/plugin-core';
import { atom } from 'jotai';

/** First authoritative failure retained through stop reconciliation and modal acknowledgement. */
export const wavWriterFailureAtom = atom<WavWriterFailurePayload | undefined>(undefined);
